import { render, staticRenderFns } from "./SLACardLabel.vue?vue&type=template&id=2792367e&"
import script from "./SLACardLabel.vue?vue&type=script&lang=js&"
export * from "./SLACardLabel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2792367e')) {
      api.createRecord('2792367e', component.options)
    } else {
      api.reload('2792367e', component.options)
    }
    module.hot.accept("./SLACardLabel.vue?vue&type=template&id=2792367e&", function () {
      api.rerender('2792367e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/components/widgets/conversation/components/SLACardLabel.vue"
export default component.exports